import { render, staticRenderFns } from "./assistenzaForm.vue?vue&type=template&id=0178ce8a&"
import script from "./assistenzaForm.vue?vue&type=script&lang=ts&"
export * from "./assistenzaForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports